"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4223],{

/***/ 89274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SectionIconWithTextList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55022);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75762);



const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .SectionWrapper */ .Uq, {
    "& > div:last-child": {
        borderBottom: "1px solid $gray500_01"
    }
});
const ItemWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    padding: "$12 0 $20",
    borderTop: "1px solid $gray500_01",
    "@md": {
        padding: "$16 0 $24",
        display: "grid",
        justifyContent: "space-between",
        gap: "$48",
        alignItems: "center"
    }
});
const Title = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("p", {
    projectFont: "ui03",
    textTransform: "uppercase",
    marginBottom: "0 !important",
    "@md": {
        gridColumn: "1/3",
        gridRow: 1
    }
});
const Text = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("p", {
    projectFont: "body04",
    marginTop: "0 !important",
    "@md": {
        gridColumn: 2,
        gridRow: 2,
        width: 330
    }
});
const IconWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    width: "80px",
    paddingBottom: "$8",
    paddingTop: "$24",
    "@md": {
        paddingBottom: 0,
        paddingTop: 0,
        gridColumn: 1,
        gridRow: 2
    }
});
const SectionIconWithTextList = (param)=>{
    let { items  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSectionWrapper, {
        type: "RICH_TEXT_SM",
        children: items === null || items === void 0 ? void 0 : items.map((item, index)=>{
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ItemWrap, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                        children: item === null || item === void 0 ? void 0 : item.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrap, {
                        children: (item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Media */ .pU, {
                            ...item === null || item === void 0 ? void 0 : item.icon,
                            layout: "responsive",
                            sizes: "80px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                        children: item === null || item === void 0 ? void 0 : item.text
                    })
                ]
            }, "".concat(index, "-").concat(item.title));
        })
    });
};


/***/ }),

/***/ 14618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionQuote": function() { return /* binding */ SectionQuote; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55022);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75762);



const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .SectionWrapper */ .Uq, {
    "@lg": {
        padding: "0 $20"
    }
});
const Quote = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("p", {
    projectFont: "heading06",
    marginTop: "$96",
    textAlign: "center"
});
const Author = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("p", {
    textAlign: "center",
    projectFont: "body03"
});
const SectionQuote = (param)=>{
    let { quote , author  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledSectionWrapper, {
        type: "RICH_TEXT_MD",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Quote, {
                children: quote
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Author, {
                children: author
            })
        ]
    });
};


/***/ }),

/***/ 79689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionSingleMediaWithDescription": function() { return /* binding */ SectionSingleMediaWithDescription; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16405);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75762);




const PLAYBACK_VISIBLE_RATIO = 0.5;
const RESET_PLAYBACK_HIDDEN_MS = 2000;
const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .SectionWrapper */ .Uq, {
    display: "grid",
    rowGap: "$20"
});
const Description = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("p", {
    projectFont: "body04",
    color: "$black_06",
    maxWidth: "$singleMediaMaxWidth",
    marginLeft: "auto",
    marginRight: "auto"
});
const MediaWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    variants: {
        mode: {
            "full-width": {
                "@lg": {
                    containerSpace: "medium"
                }
            },
            "with-margins": {
                containerSpace: "medium"
            },
            inline: {}
        }
    }
});
const DescriptionWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    variants: {
        mode: {
            "full-width": {
                containerSpace: "medium"
            },
            "with-margins": {
                containerSpace: "medium"
            },
            inline: {}
        }
    }
});
const SectionSingleMediaWithDescription = (param)=>{
    let { mode ="full-width" , mediaField , mediaDescription , priority  } = param;
    const media = mediaField === null || mediaField === void 0 ? void 0 : mediaField.media;
    const mediaWrapRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const videoElementRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const resetTimeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const shouldResetOnNextVisibleRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    const pausedByVisibilityRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    const [mediaResetVersion, setMediaResetVersion] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const isVideoMedia = (media === null || media === void 0 ? void 0 : media.mediaPayload.type) === "mux-video";
    const mediaElementKey = isVideoMedia ? "article-video-".concat(mediaResetVersion) : "article-media";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!isVideoMedia || !mediaWrapRef.current) {
            return;
        }
        const mediaWrapElement = mediaWrapRef.current;
        const handleVideoEvent = (event)=>{
            if (!(event.target instanceof HTMLVideoElement)) {
                return;
            }
            videoElementRef.current = event.target;
        };
        mediaWrapElement.addEventListener("play", handleVideoEvent, true);
        mediaWrapElement.addEventListener("loadeddata", handleVideoEvent, true);
        const clearResetTimeout = ()=>{
            if (resetTimeoutRef.current === null) {
                return;
            }
            window.clearTimeout(resetTimeoutRef.current);
            resetTimeoutRef.current = null;
        };
        const observer = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            const currentVideoElement = videoElementRef.current;
            const isVisibleEnough = entry.intersectionRatio >= PLAYBACK_VISIBLE_RATIO;
            if (!currentVideoElement) {
                return;
            }
            if (!isVisibleEnough) {
                if (!currentVideoElement.paused) {
                    currentVideoElement.pause();
                    pausedByVisibilityRef.current = true;
                }
                if (!pausedByVisibilityRef.current) {
                    clearResetTimeout();
                    return;
                }
                if (entry.intersectionRatio === 0) {
                    if (resetTimeoutRef.current === null) {
                        resetTimeoutRef.current = window.setTimeout(()=>{
                            shouldResetOnNextVisibleRef.current = true;
                            resetTimeoutRef.current = null;
                        }, RESET_PLAYBACK_HIDDEN_MS);
                    }
                } else {
                    clearResetTimeout();
                }
                return;
            }
            clearResetTimeout();
            if (shouldResetOnNextVisibleRef.current) {
                shouldResetOnNextVisibleRef.current = false;
                pausedByVisibilityRef.current = false;
                setMediaResetVersion((currentVersion)=>currentVersion + 1);
                return;
            }
            if (pausedByVisibilityRef.current) {
                pausedByVisibilityRef.current = false;
                if (currentVideoElement.paused) {
                    currentVideoElement.play().catch(()=>undefined);
                }
            }
        }, {
            threshold: [
                0,
                PLAYBACK_VISIBLE_RATIO
            ]
        });
        observer.observe(mediaWrapElement);
        return ()=>{
            observer.disconnect();
            mediaWrapElement.removeEventListener("play", handleVideoEvent, true);
            mediaWrapElement.removeEventListener("loadeddata", handleVideoEvent, true);
            clearResetTimeout();
            videoElementRef.current = null;
            shouldResetOnNextVisibleRef.current = false;
            pausedByVisibilityRef.current = false;
        };
    }, [
        isVideoMedia,
        mediaResetVersion
    ]);
    if (!media) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledSectionWrapper, {
        type: mode === "full-width" ? "RICH_TEXT_LG" : "RICH_TEXT_SM",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MediaWrap, {
                mode: mode,
                ref: mediaWrapRef,
                children: mediaField._type === "simpleMedia" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Media */ .pU, {
                    ...media,
                    priority: priority
                }, mediaElementKey) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .MediaWithBackground */ .xu, {
                    media: media,
                    color: mediaField.color,
                    mediaBorder: mediaField.mediaBorder,
                    priority: priority,
                    appearance: "singleMedia"
                }, mediaElementKey)
            }),
            mediaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DescriptionWrap, {
                mode: mode,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Description, {
                    children: [
                        "↑ ",
                        mediaDescription
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 74223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* reexport */ DefaultPage; }
});

// UNUSED EXPORTS: PasswordProtected

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(79570);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(16405);
// EXTERNAL MODULE: ../../libs/styles/src/index.ts + 15 modules
var src = __webpack_require__(55022);
// EXTERNAL MODULE: ../../libs/components/src/index.ts + 122 modules
var components_src = __webpack_require__(75762);
;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionIntroTexts/SectionIntroTexts.tsx




const TEXT_WRAPPER_HEIGHT = 40;
const CALCULATED_PADDING = 50 - TEXT_WRAPPER_HEIGHT / 2;
const ANIMATION_ROOT_MARGIN = 50 - TEXT_WRAPPER_HEIGHT;
const StyledSectionWrapper = (0,src/* styled */.zo)(components_src/* SectionWrapper */.Uq, {
    background: "$darkThemeBackground",
    paddingBottom: "$120",
    color: "$white",
    paddingTop: "".concat(CALCULATED_PADDING, "vh")
});
const TextWrap = (0,src/* styled */.zo)(components_src/* Container */.W2, {
    maxWidth: "$aboutPageContentWidth",
    margin: "0 auto",
    minHeight: "".concat(TEXT_WRAPPER_HEIGHT, "vh"),
    projectFont: "heading02",
    transition: "opacity 1s, transform 1s",
    display: "grid",
    alignContent: "center",
    variants: {
        isVisible: {
            true: {
                opacity: 1
            },
            false: {
                opacity: 0.1
            }
        }
    }
});
const Text = (param)=>{
    let { text  } = param;
    const ref = (0,react.useRef)(null);
    const [isVisible, setIsVisible] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry.isIntersecting) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        }, {
            root: null,
            rootMargin: "-".concat(ANIMATION_ROOT_MARGIN, "% 0px -").concat(ANIMATION_ROOT_MARGIN, "% 0px"),
            threshold: 1
        });
        observer.observe(ref.current);
        return ()=>{
            ref.current && observer.unobserve(ref.current);
        };
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWrap, {
        ref: ref,
        isVisible: isVisible,
        children: text
    });
};
const SectionIntroTexts = (param)=>{
    let { texts  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSectionWrapper, {
        type: "NO_MARGIN",
        children: texts === null || texts === void 0 ? void 0 : texts.map((text, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                text: text
            }, "intro-text-".concat(index)))
    });
};

// EXTERNAL MODULE: ../../node_modules/react-i18next/dist/es/index.js + 14 modules
var es = __webpack_require__(61349);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../libs/configs/src/index.ts + 7 modules
var configs_src = __webpack_require__(85109);
;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionArticlesLandingPage/SectionArticlesLandingPage.tsx






const SectionArticlesLandingPage_StyledSectionWrapper = (0,src/* styled */.zo)(components_src/* SectionWrapper */.Uq, {
    marginBottom: "$mobileSectionMarginL",
    "@lg": {
        marginBottom: "$desktopSectionMarginL"
    }
});
const Title = (0,src/* styled */.zo)("h1", {
    projectFont: "heading01",
    textAlign: "center",
    marginBottom: "92px",
    paddingInline: "$20"
});
const ArticlesGrid = (0,src/* styled */.zo)("div", {
    margin: "0 auto",
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "$56",
    maxWidth: "100%",
    "@md": {
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "$64 $24"
    }
});
const Article = (0,src/* styled */.zo)("div", {
    position: "relative",
    width: "100%"
});
const ArticleTitle = (0,src/* styled */.zo)("h3", {
    projectFont: "heading07",
    gridRow: 2,
    gridColumn: 1
});
const ArticleGridContent = (0,src/* styled */.zo)("div", {
    position: "relative",
    display: "grid",
    rowGap: "$24",
    width: "100%",
    paddingTop: "$20",
    "@md": {
        rowGap: "$32"
    }
});
const MediaWrap = (0,src/* styled */.zo)("div", {
    gridColumn: 1,
    gridRow: 1,
    borderRadius: "$r2",
    overflow: "hidden",
    transition: "transform .5s ease",
    "& img": {
        transition: "transform .5s ease"
    },
    "@md": {
        "&:hover": {
            "& img": {
                transform: "scale(1.04)"
            }
        }
    }
});
const ArticleTags = (0,src/* styled */.zo)("div", {
    display: "flex",
    flexWrap: "wrap",
    gridColumn: 1,
    gridRow: 1,
    columnGap: "$12"
});
const ArticleTag = (0,src/* styled */.zo)("div", {
    display: "flex",
    flexWrap: "wrap",
    gap: "$10"
});
const StyledLink = (0,src/* styled */.zo)(components_src/* Link */.rU, {
    zIndex: "$content",
    projectFont: "heading08",
    textDecoration: "underline",
    gridColumn: 1,
    gridRow: 3,
    textUnderlineOffset: ".35em"
});
const SectionArticlesLandingPage = (param)=>{
    let { title , articles , tags , priority  } = param;
    const { t  } = (0,es/* useTranslation */.$G)("articles");
    const { asPath  } = (0,router.useRouter)();
    const pathname = (asPath === null || asPath === void 0 ? void 0 : asPath.split("?")[0]) || "";
    const isCategoryPage = new RegExp("^".concat(configs_src/* ROUTE_CATEGORY_ARTICLE.replace */.pr.replace("/", "\\/"), "/[^/]+$")).test(pathname);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionArticlesLandingPage_StyledSectionWrapper, {
        type: "FIRST_SECTION",
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: title
            }),
            tags && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* TagsGroup */.Yj, {
                tags: tags.map((tag)=>({
                        title: tag.title,
                        value: tag.path,
                        selected: tag.path === pathname,
                        href: tag.path
                    })),
                additionalTag: isCategoryPage ? {
                    title: "Clear",
                    href: configs_src/* ROUTE_BASE_ARTICLE */.d5
                } : undefined
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Container */.W2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlesGrid, {
                    children: articles && articles.map((article, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Article, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: article.path,
                                    tabIndex: -1,
                                    "aria-label": "Article - ".concat(article.title),
                                    children: article.thumbnail && /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaWrap, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Media */.pU, {
                                            ...article.thumbnail,
                                            hardcropRatio: "landscape3",
                                            priority: priority && index < 3,
                                            sizes: "(min-width: 740px) 50vw, 100vw"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArticleGridContent, {
                                    children: [
                                        article.tags && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleTags, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleTag, {
                                                children: article.tags.map((tag)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Chip */.Af, {
                                                        title: tag.title,
                                                        type: "dark",
                                                        href: tag.path
                                                    }, tag.path))
                                            })
                                        }),
                                        article.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleTitle, {
                                            children: article.title
                                        }),
                                        article.path && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                            href: article.path,
                                            appearance: "text",
                                            children: t("readArticle")
                                        })
                                    ]
                                })
                            ]
                        }, article.path))
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../libs/article/src/index.ts + 2 modules
var article_src = __webpack_require__(82607);
// EXTERNAL MODULE: ../../libs/page-builder/src/lib/SectionQuote/SectionQuote.tsx
var SectionQuote = __webpack_require__(14618);
// EXTERNAL MODULE: ../../libs/page-builder/src/lib/SectionIconWithTextList/SectionIconWithTextList.tsx
var SectionIconWithTextList = __webpack_require__(89274);
// EXTERNAL MODULE: ../../libs/page-builder/src/lib/SectionSingleMediaWithDescription/SectionSingleMediaWithDescription.tsx
var SectionSingleMediaWithDescription = __webpack_require__(79689);
;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionArticleDetails/SectionArticleDetails.tsx








const SectionArticleDetails_StyledSectionWrapper = (0,src/* styled */.zo)(components_src/* SectionWrapper */.Uq, {
    display: "grid",
    gap: "$32",
    marginBottom: "$24",
    "@lg": {
        gap: 0,
        gridTemplateColumns: "1fr 2fr .25fr",
        marginBottom: "$48"
    }
});
const TagWrap = (0,src/* styled */.zo)("div", {
    display: "grid",
    gridTemplateRows: "auto",
    gap: "$10"
});
const TagList = (0,src/* styled */.zo)("div", {
    display: "grid",
    gridAutoFlow: "column",
    justifyContent: "start",
    gap: "$10",
    containerSpace: "medium",
    overflowX: "auto",
    overflowY: "hidden",
    "&::-webkit-scrollbar": {
        display: "none"
    },
    "@lg": {
        gridAutoFlow: "row",
        justifyItems: "start",
        overflow: "visible"
    }
});
const ContentWrap = (0,src/* styled */.zo)(components_src/* Container */.W2, {
    display: "grid",
    gap: "$16",
    "@lg": {
        gridColumn: "2/span 1",
        maxWidth: "$containerMaxWidthForSidebarLayout",
        gap: "$32"
    }
});
const SectionArticleDetails_Title = (0,src/* styled */.zo)("h1", {
    projectFont: "heading09"
});
const CategoryText = (0,src/* styled */.zo)("span", {
    projectFont: "ui04",
    textTransform: "uppercase",
    containerSpace: "medium"
});
const SectionArticleDetails = (param)=>{
    let { title , introduction , tags  } = param;
    const setVisibleChapterId = (0,article_src/* useSetVisibleChapterId */.ku)();
    const ref = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry.isIntersecting && title) {
                setVisibleChapterId(title);
            }
        }, {
            root: null,
            rootMargin: "0px 0px -90% 0px"
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        setVisibleChapterId,
        title
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionArticleDetails_StyledSectionWrapper, {
        ref: ref,
        type: "FIRST_SECTION",
        children: [
            (tags === null || tags === void 0 ? void 0 : tags.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagWrap, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryText, {
                            children: "Category: "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TagList, {
                            children: tags === null || tags === void 0 ? void 0 : tags.map((tag)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Chip */.Af, {
                                    title: tag.title,
                                    type: "dark",
                                    href: tag.path
                                }, tag.path))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrap, {
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionArticleDetails_Title, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* PortableText */.YI, {
                        value: introduction,
                        // this section has explicit top and bottom margins so we disable them on PortableText. Section is display: grid, so margin collapsing doesn't work anyway.
                        disableTopBottomMargins: true,
                        additionalComponents: {
                            types: {
                                sectionQuote: (props)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionQuote.SectionQuote, {
                                        ...props.value
                                    });
                                },
                                sectionIconWithTextList: (props)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionIconWithTextList/* SectionIconWithTextList */.Z, {
                                        ...props.value
                                    });
                                },
                                sectionSingleMediaWithDescription: (props)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionSingleMediaWithDescription.SectionSingleMediaWithDescription, {
                                        ...props.value
                                    });
                                }
                            }
                        }
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionCaseStudyHero/SectionCaseStudyHero.tsx



const SectionCaseStudyHero_StyledSectionWrapper = (0,src/* styled */.zo)(components_src/* SectionWrapper */.Uq, {
    position: "relative",
    display: "grid",
    height: "75vh",
    "@lg": {
        height: "110vh"
    }
});
const ContainerStyled = (0,src/* styled */.zo)(components_src/* Container */.W2, {
    marginTop: "$32",
    marginBottom: "$32"
});
const SectionCaseStudyHero_ContentWrap = (0,src/* styled */.zo)(components_src/* Container */.W2, {
    gridColumn: 1,
    gridRow: 1,
    display: "grid",
    gap: "$40",
    zIndex: "$content",
    color: "$white",
    position: "sticky",
    bottom: "$48",
    justifySelf: "center",
    alignSelf: "flex-end",
    justifyItems: "center",
    alignItems: "center",
    justifyContent: "center",
    margin: "$56 0",
    "@lg": {
        margin: "$96 0",
        bottom: "$96"
    }
});
const SectionCaseStudyHero_Title = (0,src/* styled */.zo)("h1", {
    projectFont: "heading03",
    textTransform: "uppercase"
});
const ShortDescription = (0,src/* styled */.zo)("h2", {
    projectFont: "heading01",
    textAlign: "center",
    maxWidth: 1100
});
const Services = (0,src/* styled */.zo)("ul", {
    listStyleType: "none",
    flexWrap: "wrap",
    gap: "$10",
    listStyle: "none",
    variants: {
        device: {
            desktop: {
                display: "none",
                "@md": {
                    display: "flex"
                }
            },
            mobile: {
                display: "flex",
                "@md": {
                    display: "none"
                }
            }
        }
    }
});
const SectionCaseStudyHero_MediaWrap = (0,src/* styled */.zo)("div", {
    gridColumn: 1,
    gridRow: 1
});
const InnerWrap = (0,src/* styled */.zo)("div", {
    height: "100%",
    width: "100%",
    position: "absolute",
    top: 0,
    left: 0
});
const SectionCaseStudyHero = (param)=>{
    let { image , name , shortDescription , priority , services  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionCaseStudyHero_StyledSectionWrapper, {
                type: "NO_MARGIN",
                children: [
                    image && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionCaseStudyHero_MediaWrap, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerWrap, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Media */.pU, {
                                ...image,
                                hardcropRatio: "landscape1",
                                layout: "fill",
                                priority: priority,
                                // Some images used in this section are very large and requires higher quality.
                                // It would be better to have this kind of control in the GROQ projection for media.
                                quality: 95,
                                controlsPosition: "bottom-right"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionCaseStudyHero_ContentWrap, {
                        children: [
                            name && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionCaseStudyHero_Title, {
                                children: name
                            }),
                            shortDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortDescription, {
                                children: shortDescription
                            }),
                            services && /*#__PURE__*/ (0,jsx_runtime.jsx)(Services, {
                                device: "desktop",
                                children: services.map((s, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Pill */.DR, {
                                            appearance: "UI05",
                                            backdrop: true,
                                            children: s
                                        })
                                    }, i))
                            })
                        ]
                    })
                ]
            }),
            services && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerStyled, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Services, {
                    device: "mobile",
                    children: services.map((s, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Pill */.DR, {
                                appearance: "UI05Black",
                                children: s
                            })
                        }, i))
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionProjectCardGrid/SectionProjectCardGrid.tsx




const SectionProjectCardGrid_StyledSectionWrapper = (0,src/* styled */.zo)(components_src/* SectionWrapper */.Uq, {
    backgroundColor: "$darkThemeBackground",
    color: "$white",
    display: "grid",
    gap: "$96",
    "@md": {
        gap: "$120"
    },
    variants: {
        spacing: {
            default: {
                marginTop: "$mobileSectionMarginL",
                marginBottom: "$mobileSectionMarginL",
                "@md": {
                    marginTop: "$desktopSectionMarginL",
                    marginBottom: "$desktopSectionMarginL"
                }
            },
            medium: {
                marginTop: "$mobileSectionMarginM",
                marginBottom: "$mobileSectionMarginM",
                paddingBlock: "$24",
                gap: "$64",
                "@lg": {
                    marginTop: "$desktopSectionMarginM",
                    marginBottom: "$desktopSectionMarginM"
                }
            },
            firstSection: {
                paddingTop: "calc($headerHeight + $mobileSectionMarginL)",
                paddingBottom: "$mobileSectionMarginL",
                "@md": {
                    paddingTop: "calc($headerHeight + $desktopSectionMarginL)",
                    paddingBottom: "$desktopSectionMarginL"
                }
            },
            none: {
                marginTop: 0,
                marginBottom: 0
            }
        },
        topBorder: {
            true: {
                borderTop: "1px solid $gray500",
                paddingBlock: "$24",
                gap: "$64"
            },
            false: {}
        }
    },
    defaultVariants: {
        spacing: "default"
    }
});
const SectionProjectCardGrid_Title = (0,src/* styled */.zo)("h2", {
    projectFont: "heading04",
    fontSize: "36px",
    width: "100%",
    containerSpace: "small",
    textAlign: "left",
    "@xxl": {
        maxWidth: "$maxWidthDesktop",
        margin: "auto",
        textAlign: "center"
    }
});
const CardLink = (0,src/* styled */.zo)(components_src/* Link */.rU, {
    pointerEvents: "all",
    zIndex: "$cardButton"
});
const ProjectsGrid = (0,src/* styled */.zo)("div", {
    display: "grid",
    gridTemplateColumns: "1fr",
    rowGap: "$72",
    "@lg": {
        gridTemplateColumns: "1fr 1fr",
        rowGap: "$168",
        columnGap: "1px"
    },
    variants: {
        single: {
            true: {
                "@lg": {
                    gridTemplateColumns: "minmax(0, 50vw)",
                    justifyContent: "center"
                }
            },
            false: {}
        }
    }
});
const ProjectCardWrap = (0,src/* styled */.zo)("div", {
    display: "grid",
    gridTemplateRows: "auto 1fr",
    gap: "$32",
    ["& ".concat(CardLink)]: {
        opacity: 1
    },
    "@lg": {
        gap: "$40",
        ["& ".concat(CardLink)]: {
            opacity: 0,
            transition: "250ms opacity"
        },
        "&:hover, &:focus-within": {
            ["& ".concat(CardLink)]: {
                opacity: 1,
                transition: "250ms opacity"
            }
        }
    }
});
const SectionProjectCardGrid_ContentWrap = (0,src/* styled */.zo)(components_src/* Container */.W2, {
    display: "grid",
    gap: "$32",
    justifyItems: "flex-start",
    color: "$white",
    gridColumn: 1,
    gridRow: 2,
    pointerEvents: "none",
    "@lg": {
        alignContent: "flex-start",
        gridTemplateColumns: "1fr auto",
        justifyContent: "space-between"
    }
});
const Description = (0,src/* styled */.zo)("h3", {
    projectFont: "heading07",
    color: "$white_07",
    maxWidth: 480,
    zIndex: "$content"
});
const CaseStudyName = (0,src/* styled */.zo)("span", {
    color: "$white",
    zIndex: "$content"
});
const LinkWrap = (0,src/* styled */.zo)(components_src/* Link */.rU, {
    gridColumn: 1,
    gridRow: "1 / -1",
    zIndex: "$content"
});
const SectionProjectCardGrid_MediaWrap = (0,src/* styled */.zo)("div", {
    gridColumn: 1,
    gridRow: 1
});
const SectionProjectCardGrid = (param)=>{
    let { title , spacing ="default" , projects , priority , topBorder  } = param;
    const { t  } = (0,es/* useTranslation */.$G)("caseStudy");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionProjectCardGrid_StyledSectionWrapper, {
        type: "NO_MARGIN",
        spacing: spacing,
        topBorder: topBorder,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionProjectCardGrid_Title, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectsGrid, {
                single: (projects === null || projects === void 0 ? void 0 : projects.length) === 1,
                children: projects === null || projects === void 0 ? void 0 : projects.map((project, index)=>{
                    var _project_caseStudy, _project_caseStudy1, _project_caseStudy2, _project_caseStudy3, _project_caseStudy4, _project_caseStudy5, _project_caseStudy6;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ProjectCardWrap, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionProjectCardGrid_MediaWrap, {
                                children: project.media && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Media */.pU, {
                                    controlsPosition: "bottom-right",
                                    ...project.media,
                                    loop: true,
                                    priority: priority && index < 4,
                                    sizes: "(min-width: 1000px) 50vw, 100vw"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionProjectCardGrid_ContentWrap, {
                                spaceSize: "small",
                                children: [
                                    project.text && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Description, {
                                        as: title ? "h3" : "h2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseStudyName, {
                                                children: project === null || project === void 0 ? void 0 : (_project_caseStudy = project.caseStudy) === null || _project_caseStudy === void 0 ? void 0 : _project_caseStudy.name
                                            }),
                                            " ",
                                            project.text
                                        ]
                                    }),
                                    (project === null || project === void 0 ? void 0 : (_project_caseStudy1 = project.caseStudy) === null || _project_caseStudy1 === void 0 ? void 0 : _project_caseStudy1.path) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardLink, {
                                        appearance: "outlinedWhite",
                                        href: project === null || project === void 0 ? void 0 : (_project_caseStudy2 = project.caseStudy) === null || _project_caseStudy2 === void 0 ? void 0 : _project_caseStudy2.path,
                                        children: t("viewCaseStudy")
                                    })
                                ]
                            }),
                            (project === null || project === void 0 ? void 0 : (_project_caseStudy3 = project.caseStudy) === null || _project_caseStudy3 === void 0 ? void 0 : _project_caseStudy3.path) && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrap, {
                                tabIndex: -1,
                                href: project === null || project === void 0 ? void 0 : (_project_caseStudy4 = project.caseStudy) === null || _project_caseStudy4 === void 0 ? void 0 : _project_caseStudy4.path,
                                appearance: "grid",
                                label: "Case Study - ".concat(project === null || project === void 0 ? void 0 : (_project_caseStudy5 = project.caseStudy) === null || _project_caseStudy5 === void 0 ? void 0 : _project_caseStudy5.name)
                            })
                        ]
                    }, "card-".concat((_project_caseStudy6 = project.caseStudy) === null || _project_caseStudy6 === void 0 ? void 0 : _project_caseStudy6.name, "-").concat(index));
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionHomeHero/SectionHomeHero.tsx




const SectionHomeHero_Text = (0,src/* styled */.zo)("h1", {
    textAlign: "center",
    projectFont: "display02",
    maxWidth: "$homeHeroTextWidth",
    margin: "0 auto",
    variants: {
        textTheme: {
            light: {
                color: "$white"
            },
            dark: {
                color: "$black"
            }
        }
    }
});
const SectionHomeHero_StyledSectionWrapper = (0,src/* styled */.zo)(components_src/* SectionWrapper */.Uq, {
    display: "grid",
    gap: "$72",
    containerSpace: "medium",
    marginBottom: "$mobileSectionMarginL",
    "@lg": {
        marginBottom: "$desktopSectionMarginL"
    },
    "@xxl": {
        padding: "$48 0"
    }
});
const LogosWrap = (0,src/* styled */.zo)("div", {
    display: "grid",
    gridAutoFlow: "column",
    gap: "$32",
    margin: "0 auto",
    "@sm": {
        gap: "$40"
    },
    "@md": {
        gap: "$48"
    }
});
const Logos = (0,src/* styled */.zo)("div", {
    position: "relative",
    width: 76,
    "@md": {
        width: "$96"
    },
    height: "$36",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const Logo = (0,src/* styled */.zo)("span", {
    transition: "opacity .2s ease-in-out, transform .3s , visibility .3s ",
    position: "absolute",
    left: "0",
    right: "0",
    variants: {
        status: {
            active: {
                opacity: "1",
                transform: "translateY(0)",
                visibility: "visible"
            },
            hidden: {
                opacity: "0",
                transform: "translateY(-20px)",
                visibility: "hidden"
            }
        }
    }
});
const SectionHomeHero = (param)=>{
    let { text , technologiesRows , textTheme ="dark" , priority  } = param;
    var _technologiesRows_;
    const TIMEOUT_ANIMATION = 4000;
    const DELAY_MULTIPLIER = 150;
    const [counter, setCounter] = (0,react.useState)(0);
    const itemsArray = technologiesRows && technologiesRows[0].items ? [
        ...new Array((_technologiesRows_ = technologiesRows[0]) === null || _technologiesRows_ === void 0 ? void 0 : _technologiesRows_.items.length)
    ] : [];
    (0,react.useEffect)(()=>{
        const rowsNum = technologiesRows === null || technologiesRows === void 0 ? void 0 : technologiesRows.length;
        if (!rowsNum) return setCounter(0);
        const interval = setInterval(()=>{
            setCounter((val)=>val < rowsNum - 1 ? val + 1 : 0);
        }, TIMEOUT_ANIMATION);
        return ()=>clearInterval(interval);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionHomeHero_StyledSectionWrapper, {
        type: "FIRST_SECTION",
        children: [
            text && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHomeHero_Text, {
                textTheme: textTheme,
                children: text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogosWrap, {
                children: itemsArray.map((_, index)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos, {
                        children: technologiesRows === null || technologiesRows === void 0 ? void 0 : technologiesRows.map((el, i)=>{
                            const isActive = i === counter;
                            return el.items && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                                status: isActive ? "active" : "hidden",
                                style: {
                                    transitionDelay: "".concat(index * DELAY_MULTIPLIER + (isActive ? 100 : 0), "ms")
                                },
                                children: el.items[index].mediaPayload && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Media */.pU, {
                                    ...el.items[index],
                                    priority: priority && i === 0,
                                    sizes: "80px",
                                    disablePlaceholderBackground: true
                                })
                            }, "".concat(el.items[index].alt, "-").concat(i));
                        })
                    }, "logos-column-".concat(index));
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionProjectCard/SectionProjectCard.tsx



const Wrap = (0,src/* styled */.zo)(components_src/* SectionWrapper */.Uq, {
    display: "grid",
    gridTemplateRows: "auto auto",
    gap: "$32",
    "@lg": {
        gridTemplateRows: "1fr 400px",
        gap: "$32"
    }
});
const SectionProjectCard_MediaWrap = (0,src/* styled */.zo)("div", {
    gridRow: 1,
    gridColumn: 1,
    "@lg": {
        gridColumn: 1,
        gridRow: "1 / 3"
    }
});
const SectionProjectCard_ContentWrap = (0,src/* styled */.zo)(components_src/* Container */.W2, {
    color: "$darkThemeBackground",
    display: "grid",
    gap: "$24",
    justifyItems: "flex-start",
    gridRow: 2,
    gridColumn: 1,
    pointerEvents: "none",
    "@lg": {
        background: "linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3))",
        zIndex: "$content",
        alignContent: "flex-end",
        gridTemplateColumns: "480px auto",
        justifyContent: "space-between",
        paddingBottom: "$40",
        color: "$white"
    }
});
const SectionProjectCard_Description = (0,src/* styled */.zo)("h2", {
    projectFont: "heading07",
    color: "$white_07",
    zIndex: "$content"
});
const SectionProjectCard_CaseStudyName = (0,src/* styled */.zo)("span", {
    color: "$white",
    zIndex: "$content"
});
const SectionProjectCard_LinkWrap = (0,src/* styled */.zo)(components_src/* Link */.rU, {
    gridColumn: 1,
    gridRow: "1 / -1",
    zIndex: "$content",
    "&:focus-visible": {
        outline: "$focusBlue solid 5px;",
        outlineOffset: "-5px"
    }
});
const SectionProjectCard_Services = (0,src/* styled */.zo)("ul", {
    display: "flex",
    flexWrap: "wrap",
    gap: "$10",
    listStyle: "none",
    "@lg": {
        alignSelf: "end",
        justifyContent: "end"
    }
});
const SectionProjectCard = (param)=>{
    let { text , caseStudy , media , priority  } = param;
    const isLg = (0,src/* useMediaQuery */.ac)("lg");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrap, {
        type: "CARD",
        children: [
            media && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionProjectCard_MediaWrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Media */.pU, {
                    controlsPosition: isLg ? "top-right" : "bottom-right",
                    ...media,
                    loop: true,
                    priority: priority
                })
            }),
            caseStudy && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionProjectCard_ContentWrap, {
                spaceSize: "small",
                children: [
                    text && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionProjectCard_Description, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionProjectCard_CaseStudyName, {
                                children: caseStudy.name
                            }),
                            " ",
                            text
                        ]
                    }),
                    caseStudy.services && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionProjectCard_Services, {
                        children: caseStudy.services.map((s, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Pill */.DR, {
                                    appearance: "UI05",
                                    backdrop: true,
                                    children: s
                                })
                            }, i))
                    })
                ]
            }),
            caseStudy.path && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionProjectCard_LinkWrap, {
                href: caseStudy.path,
                appearance: "grid",
                label: "Case Study - ".concat(caseStudy.name)
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionContact/SectionContact.tsx




const StyledContainer = (0,src/* styled */.zo)(components_src/* SectionWrapper */.Uq, {
    marginTop: "$168",
    containerSpace: "medium"
});
const ContactWrap = (0,src/* styled */.zo)("div", {
    "@md": {
        width: "max-content",
        margin: "0 auto"
    }
});
const SectionContact_Title = (0,src/* styled */.zo)("h1", {
    projectFont: "display01",
    marginBottom: "$120",
    textAlign: "center"
});
const Contact = (0,src/* styled */.zo)("div", {
    padding: "$28 0 $32",
    borderTop: "1px solid $gray500_01"
});
const ContactTitle = (0,src/* styled */.zo)("h2", {
    projectFont: "heading08",
    marginBottom: "$8"
});
const ContactMail = (0,src/* styled */.zo)("div", {
    projectFont: "body03",
    display: "flex",
    justifyContent: "space-between"
});
const SocialsWrap = (0,src/* styled */.zo)("div", {
    padding: "$28 0 $32",
    borderTop: "1px solid $gray500_01"
});
const SocialsTitle = (0,src/* styled */.zo)("h2", {
    projectFont: "heading08",
    marginBottom: "$16"
});
const SectionContact = (param)=>{
    let { title , contacts , socials , priority  } = param;
    const { t  } = (0,es/* useTranslation */.$G)("contactPage");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactWrap, {
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContact_Title, {
                    children: title
                }),
                contacts && contacts.map((contact, index)=>{
                    var _contact_contact, _contact_contact1, _contact_contact2;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Contact, {
                        children: [
                            contact.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactTitle, {
                                children: contact.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactMail, {
                                children: [
                                    (_contact_contact = contact.contact) === null || _contact_contact === void 0 ? void 0 : _contact_contact.email,
                                    ((_contact_contact1 = contact.contact) === null || _contact_contact1 === void 0 ? void 0 : _contact_contact1.email) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* CopyButton */.qi, {
                                        copyText: (_contact_contact2 = contact.contact) === null || _contact_contact2 === void 0 ? void 0 : _contact_contact2.email,
                                        theme: "dark",
                                        context: "ContactPage - ".concat(contact.title)
                                    })
                                ]
                            })
                        ]
                    }, index);
                }),
                socials && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SocialsWrap, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialsTitle, {
                            children: t("followUs")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Socials */.I_, {
                            items: socials.items,
                            iconsColor: "dark",
                            priority: priority
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionSideTextBlock/SectionSideTextBlock.tsx



const Content = (0,src/* styled */.zo)("div", {
    display: "grid",
    gap: "$36",
    margin: "0 auto",
    containerSpace: "medium",
    width: "100%"
});
const Heading = (0,src/* styled */.zo)("h2", {
    projectFont: "heading07",
    maxWidth: "$sideTextBlockWidth",
    color: "$white_07"
});
const SectionSideTextBlock_Text = (0,src/* styled */.zo)("h3", {
    projectFont: "heading02",
    maxWidth: "$sideTextBlockWidth",
    color: "$white"
});
const SectionSideTextBlock = (param)=>{
    let { text , heading , priority  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* SectionWrapper */.Uq, {
        type: "FIRST_SECTION",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
            children: [
                heading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                    as: priority ? "h1" : "h2",
                    children: heading
                }),
                text && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionSideTextBlock_Text, {
                    as: "p",
                    children: text
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionServices/SectionServices.tsx



const SectionServices_StyledSectionWrapper = (0,src/* styled */.zo)(components_src/* SectionWrapper */.Uq, {
    color: "$white",
    display: "grid",
    "@lg": {
        gap: "unset",
        gridTemplateColumns: "1fr 2fr .25fr"
    }
});
const ServicesListContainer = (0,src/* styled */.zo)(components_src/* Container */.W2, {
    display: "grid",
    maxWidth: "840px",
    "@lg": {
        gridColumn: "2/span 1"
    }
});
const ServicesList = (0,src/* styled */.zo)("ul", {
    listStyleType: "none",
    display: "grid",
    gap: "$72",
    "@lg": {
        gap: "$120"
    }
});
const ServicesListItem = (0,src/* styled */.zo)("li", {
    display: "grid",
    gap: "30px"
});
const SectionServices_Title = (0,src/* styled */.zo)("h2", {
    projectFont: "heading04",
    color: "$white"
});
const SectionServices_Description = (0,src/* styled */.zo)("p", {
    projectFont: "body03",
    color: "$white_07"
});
const PillsList = (0,src/* styled */.zo)("ul", {
    display: "flex",
    flexWrap: "wrap",
    listStyleType: "none"
});
const PillListItem = (0,src/* styled */.zo)("li", {
    margin: "0 $8 $8 0"
});
const LinkItem = (0,src/* styled */.zo)(components_src/* Link */.rU, {
    width: "fit-content"
});
const SectionServices = (param)=>{
    let { services  } = param;
    if (!services) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionServices_StyledSectionWrapper, {
        type: "DEFAULT",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesListContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesList, {
                    children: services === null || services === void 0 ? void 0 : services.map((serviceItem)=>{
                        var _serviceItem_pills, _serviceItem_pills1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ServicesListItem, {
                            children: [
                                (serviceItem === null || serviceItem === void 0 ? void 0 : serviceItem.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionServices_Title, {
                                    children: serviceItem === null || serviceItem === void 0 ? void 0 : serviceItem.title
                                }),
                                (serviceItem === null || serviceItem === void 0 ? void 0 : serviceItem.cta) && (serviceItem === null || serviceItem === void 0 ? void 0 : serviceItem.ctaLabel) && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkItem, {
                                    ...serviceItem === null || serviceItem === void 0 ? void 0 : serviceItem.cta,
                                    appearance: "containedWhite",
                                    children: serviceItem === null || serviceItem === void 0 ? void 0 : serviceItem.ctaLabel
                                }),
                                (serviceItem === null || serviceItem === void 0 ? void 0 : serviceItem.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionServices_Description, {
                                    children: serviceItem === null || serviceItem === void 0 ? void 0 : serviceItem.description
                                }),
                                (serviceItem === null || serviceItem === void 0 ? void 0 : (_serviceItem_pills = serviceItem.pills) === null || _serviceItem_pills === void 0 ? void 0 : _serviceItem_pills.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PillsList, {
                                    children: serviceItem === null || serviceItem === void 0 ? void 0 : (_serviceItem_pills1 = serviceItem.pills) === null || _serviceItem_pills1 === void 0 ? void 0 : _serviceItem_pills1.map((service, index)=>{
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(PillListItem, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Pill */.DR, {
                                                children: service === null || service === void 0 ? void 0 : service.title
                                            })
                                        }, "".concat(service === null || service === void 0 ? void 0 : service.title, "-").concat(index));
                                    })
                                }) : null
                            ]
                        }, serviceItem === null || serviceItem === void 0 ? void 0 : serviceItem._key);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
        ]
    });
};

;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionArticleContents/SectionArticleContents.tsx






const CTA_FORM_RESERVED_HEIGHT = 211;
const TOP_OFFSET = 48;
const BOTTOM_OFFSET = 24;
const SectionArticleContents_Wrap = (0,src/* styled */.zo)("div", {
    display: "none",
    "@lg": {
        background: "$white",
        zIndex: "$header",
        display: "flex",
        flexDirection: "column",
        gap: "$72",
        position: "sticky",
        top: TOP_OFFSET,
        marginBottom: BOTTOM_OFFSET,
        maxHeight: "calc(100vh - ".concat(TOP_OFFSET, "px - ").concat(BOTTOM_OFFSET, "px)"),
        height: "fit-content",
        maxWidth: "360px"
    }
});
const Chapter = (0,src/* styled */.zo)(components_src/* Link */.rU, {
    projectFont: "ui04",
    color: "$black_05",
    display: "grid",
    gridTemplateColumns: "18px 1fr",
    gap: "$4",
    whiteSpace: "nowrap",
    variants: {
        active: {
            true: {
                color: "$black"
            }
        }
    },
    "@lg": {
        whiteSpace: "unset"
    }
});
const ChaptersWrap = (0,src/* styled */.zo)("div", {
    display: "none",
    "@lg": {
        display: "flex",
        flexDirection: "column",
        gap: "$8",
        containerSpace: "none",
        paddingTop: "$0",
        paddingBottom: "$0"
    }
});
const SliderWrap = (0,src/* styled */.zo)("div", {
    display: "none",
    "@lg": {
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        minHeight: 0,
        containerSpace: "medium",
        width: "100%",
        "&::-webkit-scrollbar": {
            width: "$6",
            height: "$6"
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "$gray50",
            borderRadius: "$rMax"
        }
    },
    variants: {
        isSticky: {
            true: {
                boxShadow: "0px 3px 10px 0px rgba(0, 0, 0, 0.1)",
                "@lg": {
                    boxShadow: "none"
                }
            }
        }
    }
});
const ContentsTitle = (0,src/* styled */.zo)("h2", {
    projectFont: "ui03",
    textTransform: "uppercase",
    marginBottom: "$20",
    display: "none",
    "@lg": {
        display: "block"
    }
});
const CtaWrap = (0,src/* styled */.zo)("div", {
    "@lg": {
        display: "block",
        flex: "0 0 auto",
        marginTop: "$24",
        containerSpace: "medium",
        paddingRight: 0
    }
});
const CtaBox = (0,src/* styled */.zo)("aside", {
    backgroundColor: "$gray50",
    borderRadius: "$rBoxes",
    padding: "$24",
    color: "$textPrimaryBlack",
    width: "100%",
    maxWidth: "330px",
    marginInline: "auto",
    "@md": {
        marginInline: "unset"
    }
});
const CtaTitle = (0,src/* styled */.zo)("h3", {
    projectFont: "heading07",
    marginBottom: "$24"
});
const CtaFormArea = (0,src/* styled */.zo)("div", {
    position: "relative",
    // Reserve height so the sidebar doesn't jump while the Klaviyo form loads.
    minHeight: CTA_FORM_RESERVED_HEIGHT
});
const CtaDisclaimer = (0,src/* styled */.zo)("p", {
    projectFont: "ui04",
    fontSize: "11px",
    color: "$gray300",
    marginTop: "$12"
});
const SectionArticleContents = (param)=>{
    let { contents , cta  } = param;
    var _contents_;
    const { t  } = (0,es/* useTranslation */.$G)("article");
    const visibleChapterId = (0,article_src/* useVisibleChapterId */.Ws)();
    const MIN_SHIFT_LEFT = 20;
    const [activeSlideScrollPos, setAtiveSlideScrollPos] = (0,react.useState)(undefined);
    const [isSticky, setIsSticky] = (0,react.useState)(false);
    const sliderRef = (0,react.useRef)(null);
    const sliderEl = sliderRef.current;
    const activeChapterElementRef = (0,react.useRef)(null);
    const { title , klaviyoFormId , disclaimer  } = cta || {};
    const showCtaBox = Boolean(cta);
    /*   Callback used every time when set active slide ref
  that set position to scroll when slide is active */ const activeSlideRef = (0,react.useCallback)((node)=>{
        if (node !== null) {
            activeChapterElementRef.current = node;
            const { offsetLeft  } = node;
            const { width  } = node.getBoundingClientRect();
            const windowWidth = window.innerWidth;
            const shiftToCenter = (windowWidth - width) / 2 > 0 ? (windowWidth - width) / 2 : MIN_SHIFT_LEFT;
            setAtiveSlideScrollPos(offsetLeft - shiftToCenter);
        }
    }, []);
    // Scroll to currently active chapter (horizontal — mobile)
    (0,react.useEffect)(()=>{
        if (activeSlideScrollPos && sliderEl) {
            sliderEl.scroll({
                left: activeSlideScrollPos
            });
        }
    }, [
        activeSlideScrollPos,
        sliderEl
    ]);
    (0,article_src/* useScrollContents */.kP)({
        activeChapterElementRef,
        sliderRef,
        visibleChapterId,
        firstChapterTitle: contents === null || contents === void 0 ? void 0 : (_contents_ = contents[0]) === null || _contents_ === void 0 ? void 0 : _contents_.chapterTitle
    });
    // Check that element is sticky for shadow
    (0,react.useEffect)(()=>{
        if (!sliderRef.current) return;
        const observer = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry.intersectionRatio < 1) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        }, {
            root: null,
            threshold: [
                1
            ]
        });
        observer.observe(sliderRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, []);
    // Add smooth scroll in that way because we want to have scroll behavior only for chapter links and not when user click link which navigates to the another page.
    const addSmoothScroll = ()=>{
        const html = document.querySelector("html");
        html === null || html === void 0 ? void 0 : html.style.setProperty("scroll-behavior", "smooth");
        setTimeout(()=>{
            return html === null || html === void 0 ? void 0 : html.style.removeProperty("scroll-behavior");
        }, 0);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionArticleContents_Wrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SliderWrap, {
                ref: sliderRef,
                isSticky: isSticky,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentsTitle, {
                        children: t("contents")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChaptersWrap, {
                        children: contents === null || contents === void 0 ? void 0 : contents.map((chapter, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Chapter, {
                                "data-active": chapter.chapterTitle === visibleChapterId,
                                active: chapter.chapterTitle === visibleChapterId,
                                href: "#".concat(chapter.chapterTitle),
                                onClick: addSmoothScroll,
                                ref: chapter.chapterTitle === visibleChapterId ? activeSlideRef : undefined,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            index + 1,
                                            "."
                                        ]
                                    }),
                                    chapter.chapterTitle
                                ]
                            }, "".concat(chapter.chapterTitle, "-").concat(index));
                        })
                    })
                ]
            }),
            showCtaBox && /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaWrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CtaBox, {
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaTitle, {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaFormArea, {
                            "aria-live": "polite",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* KlaviyoForm */.DM, {
                                formId: klaviyoFormId
                            })
                        }),
                        disclaimer && /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaDisclaimer, {
                            children: disclaimer
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionRelatedArticles/SectionRelatedArticles.tsx




const SectionRelatedArticles_ArticlesGrid = (0,src/* styled */.zo)("div", {
    margin: "0 auto",
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "$56",
    padding: "$96 0 $48",
    "@md": {
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "$64 $24",
        maxWidth: "100%"
    }
});
const SectionRelatedArticles_Article = (0,src/* styled */.zo)("div", {
    position: "relative",
    width: "100%",
    height: "100%",
    display: "grid",
    alignItems: "start",
    gridTemplateRows: "auto 1fr"
});
const SectionRelatedArticles_ArticleTitle = (0,src/* styled */.zo)("h3", {
    projectFont: "heading07",
    gridRow: 2,
    gridColumn: 1
});
const SectionRelatedArticles_ArticleGridContent = (0,src/* styled */.zo)("div", {
    position: "relative",
    display: "grid",
    rowGap: "$24",
    width: "100%",
    paddingTop: "$20",
    "@md": {
        rowGap: "$32",
        height: "100%",
        gridTemplateRows: "auto auto 1fr"
    }
});
const SectionRelatedArticles_MediaWrap = (0,src/* styled */.zo)("div", {
    gridColumn: 1,
    gridRow: 1,
    borderRadius: "$r2",
    overflow: "hidden"
});
const ReadArticle = (0,src/* styled */.zo)("span", {
    projectFont: "heading08",
    textDecoration: "underline",
    gridColumn: 1,
    gridRow: 3,
    textUnderlineOffset: ".35em",
    display: "grid",
    height: "100%",
    alignItems: "end"
});
const SectionRelatedArticles_ArticleTags = (0,src/* styled */.zo)("div", {
    display: "flex",
    flexWrap: "wrap",
    gridColumn: 1,
    gridRow: 1,
    columnGap: "$12"
});
const SectionRelatedArticles_ArticleTag = (0,src/* styled */.zo)("div", {
    display: "flex",
    flexWrap: "wrap",
    gap: "$10",
    zIndex: "$content"
});
const LinkLayer = (0,src/* styled */.zo)(components_src/* Link */.rU, {
    position: "absolute",
    width: "100%",
    height: "100%",
    cursor: "pointer",
    pointerEvents: "all"
});
const SectionArticleRelated = (param)=>{
    let { relatedArticles , priority  } = param;
    const { t  } = (0,es/* useTranslation */.$G)("articles");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Container */.W2, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionRelatedArticles_ArticlesGrid, {
            children: relatedArticles && relatedArticles.map((article, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionRelatedArticles_Article, {
                    children: [
                        article.thumbnail && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionRelatedArticles_MediaWrap, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Media */.pU, {
                                ...article.thumbnail,
                                hardcropRatio: "landscape3",
                                priority: priority && index < 3,
                                sizes: "(min-width: 740px) 50vw, 100vw"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionRelatedArticles_ArticleGridContent, {
                            children: [
                                article.tags && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionRelatedArticles_ArticleTags, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionRelatedArticles_ArticleTag, {
                                        children: article.tags.map((tag)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Chip */.Af, {
                                                title: tag.title,
                                                type: "dark",
                                                href: tag.path
                                            }, tag.path))
                                    })
                                }),
                                article.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionRelatedArticles_ArticleTitle, {
                                    children: article.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadArticle, {
                                    children: t("readArticle")
                                })
                            ]
                        }),
                        article.path && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkLayer, {
                            href: article.path,
                            tabIndex: -1,
                            "aria-label": "Article - ".concat(article.title)
                        }, article.path)
                    ]
                }, article.path))
        })
    });
};

// EXTERNAL MODULE: ../../libs/icons/src/index.ts + 18 modules
var icons_src = __webpack_require__(46115);
;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionHero/SectionHero.tsx




const SectionHeroContainer = (0,src/* styled */.zo)("section", {
    "@lg": {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gridTemplateRows: "minmax(auto, 1fr) minmax(auto, 1fr)",
        rowGap: 24,
        height: "100vh"
    }
});
const SectionHeroTitlesContainer = (0,src/* styled */.zo)("div", {
    gridRow: "1 / span 1",
    gridColumn: 1,
    display: "flex",
    flexDirection: "column",
    gap: 12,
    alignItems: "center",
    paddingBlockStart: "calc(var(--sizes-headerHeight) + 88px)",
    paddingBlockEnd: 104,
    paddingInline: 20,
    width: "100%",
    "@lg": {
        gap: 16,
        paddingInline: "$30",
        paddingBlockEnd: 0,
        paddingBlockStart: "calc(var(--sizes-headerHeight) + 104px)",
        alignItems: "flex-start"
    },
    "@xxl": {
        paddingInline: 0,
        maxWidth: "calc($maxWidthDesktop / 2)",
        marginInline: "auto 0"
    }
});
const SectionHeroSubtitle = (0,src/* styled */.zo)("h2", {
    projectFont: "heading08",
    fontSize: "16px",
    gridRow: "1 / span 1",
    gridColumn: 1,
    color: "$white",
    paddingInline: 20,
    width: "fit-content",
    display: "flex",
    height: "36px",
    padding: "0px 16px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    borderRadius: "$rMax",
    background: "rgba(255, 255, 255, 0.05)",
    backdropFilter: "blur(15px)"
});
const SectionHeroTitle = (0,src/* styled */.zo)("h1", {
    projectFont: "heading01",
    gridRow: "1 / span 1",
    color: "$white",
    maxWidth: 650
});
const SectionHeroImageMobile = (0,src/* styled */.zo)("div", {
    position: "relative",
    marginBlockEnd: 48,
    aspectRatio: "1/1",
    gridRow: "1 / span 3",
    "@lg": {
        display: "none"
    }
});
const SectionHeroImageDesktop = (0,src/* styled */.zo)("div", {
    display: "none",
    "@lg": {
        display: "block",
        gridRow: "1 / span 3",
        gridColumn: 2,
        height: "100%"
    }
});
const SectionHeroDescription = (0,src/* styled */.zo)("div", {
    display: "flex",
    flexDirection: "column",
    gap: 30,
    paddingInline: 20,
    projectFont: "heading07",
    color: "$white",
    "@lg": {
        alignSelf: "flex-start",
        maxWidth: "70%",
        paddingInline: 0
    }
});
const SectionHeroLink = (0,src/* styled */.zo)("div", {
    width: "fit-content",
    marginTop: 30,
    paddingInline: 20,
    "@lg": {
        alignSelf: "flex-start",
        margin: "0",
        paddingInline: 0
    }
});
const SectionHeroContentContainer = (0,src/* styled */.zo)("div", {
    width: "100%",
    "@lg": {
        paddingInline: "$30",
        gridRow: "2 / span 1",
        gridColumn: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        gap: 30
    },
    "@xxl": {
        paddingInline: 0,
        maxWidth: "calc($maxWidthDesktop / 2)",
        marginInline: "auto 0"
    }
});
const LinkLabel = (0,src/* styled */.zo)("span", {
    display: "block",
    marginRight: 8
});
const SectionHero = (param)=>{
    let { title , subtitle , text , media , link , linkLabel  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionHeroContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionHeroTitlesContainer, {
                children: [
                    subtitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeroSubtitle, {
                        children: subtitle
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeroTitle, {
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeroImageMobile, {
                children: (media === null || media === void 0 ? void 0 : media.mediaPayload) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Media */.pU, {
                    ...media,
                    sizes: "(min-width: 1000px) 0px, 100vw",
                    layout: "fill"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeroImageDesktop, {
                children: (media === null || media === void 0 ? void 0 : media.mediaPayload) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Media */.pU, {
                    ...media,
                    sizes: "(min-width: 1000px) 75vw, 0px",
                    layout: "fill"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionHeroContentContainer, {
                children: [
                    text ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* PortableText */.YI, {
                        value: text,
                        appearance: "plain",
                        additionalComponents: {
                            block: {
                                normal: (param)=>/*#__PURE__*/ {
                                    let { children  } = param;
                                    return (0,jsx_runtime.jsx)(SectionHeroDescription, {
                                        children: children
                                    });
                                }
                            }
                        }
                    }) : null,
                    link && linkLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeroLink, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_src/* Link */.rU, {
                            ...link,
                            appearance: "containedTransparent",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkLabel, {
                                    children: linkLabel
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src/* OpenNewTab */.mw, {})
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/PageBuilder.tsx















const DynamicSectionEditorialRichText = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2228).then(__webpack_require__.bind(__webpack_require__, 12228)).then((mod)=>mod.SectionEditorialRichText), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(12228)
            ]
    }
});
const DynamicSectionQuote = dynamic_default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 14618)).then((mod)=>mod.SectionQuote), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(14618)
            ]
    }
});
const DynamicSectionCardSlider = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9689).then(__webpack_require__.bind(__webpack_require__, 9689)).then((mod)=>mod.SectionCardSlider), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9689)
            ]
    }
});
const DynamicSectionNextProject = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2653).then(__webpack_require__.bind(__webpack_require__, 42653)).then((mod)=>mod.SectionNextProject), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(42653)
            ]
    }
});
const DynamicSectionCaseStudyDetails = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9643).then(__webpack_require__.bind(__webpack_require__, 9643)).then((mod)=>mod.SectionCaseStudyDetails), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9643)
            ]
    }
});
const DynamicSectionTextBlockWithLink = dynamic_default()(()=>__webpack_require__.e(/* import() */ 3145).then(__webpack_require__.bind(__webpack_require__, 73145)).then((mod)=>mod.SectionTextBlockWithLink), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(73145)
            ]
    }
});
const DynamicSectionTextBlocks = dynamic_default()(()=>__webpack_require__.e(/* import() */ 8914).then(__webpack_require__.bind(__webpack_require__, 28914)).then((mod)=>mod.SectionTextBlocks), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(28914)
            ]
    }
});
const DynamicSectionVideoTestimonials = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4145).then(__webpack_require__.bind(__webpack_require__, 34145)).then((mod)=>mod.SectionVideoTestimonials), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(34145)
            ]
    }
});
const DynamicSectionSingleMediaWithDescription = dynamic_default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 79689)).then((mod)=>mod.SectionSingleMediaWithDescription), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(79689)
            ]
    }
});
const DynamicSectionArticleChapter = dynamic_default()(()=>__webpack_require__.e(/* import() */ 5119).then(__webpack_require__.bind(__webpack_require__, 15119)).then((mod)=>mod.SectionArticleChapter), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(15119)
            ]
    }
});
const DynamicSectionArticleAuthor = dynamic_default()(()=>__webpack_require__.e(/* import() */ 75).then(__webpack_require__.bind(__webpack_require__, 10075)).then((mod)=>mod.SectionArticleAuthor), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10075)
            ]
    }
});
const DynamicSectionDoubleMediaWithBackground = dynamic_default()(()=>__webpack_require__.e(/* import() */ 8522).then(__webpack_require__.bind(__webpack_require__, 8522)).then((mod)=>mod.SectionDoubleMediaWithBackground), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(8522)
            ]
    }
});
const DynamicSectionCaseStudyCards = dynamic_default()(()=>__webpack_require__.e(/* import() */ 1589).then(__webpack_require__.bind(__webpack_require__, 11589)).then((mod)=>mod.SectionCaseStudyCards), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(11589)
            ]
    }
});
const DynamicSectionServicesListing = dynamic_default()(()=>__webpack_require__.e(/* import() */ 6658).then(__webpack_require__.bind(__webpack_require__, 46658)).then((mod)=>mod.SectionServicesListing), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(46658)
            ]
    }
});
const DynamicSectionTechstackSlider = dynamic_default()(()=>__webpack_require__.e(/* import() */ 5600).then(__webpack_require__.bind(__webpack_require__, 75600)).then((mod)=>mod.SectionTechstackSlider), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(75600)
            ]
    }
});
const DynamicSectionNewsletter = dynamic_default()(()=>__webpack_require__.e(/* import() */ 5864).then(__webpack_require__.bind(__webpack_require__, 45864)).then((mod)=>mod.SectionNewsletter), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(45864)
            ]
    }
});
const DynamicSectionSocialMediaEmbed = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7995).then(__webpack_require__.bind(__webpack_require__, 37995)).then((mod)=>mod.SectionSocialMediaEmbed), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(37995)
            ]
    }
});
const DynamicSectionFeaturedBlogPosts = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4395).then(__webpack_require__.bind(__webpack_require__, 34395)).then((mod)=>mod.SectionFeaturedBlogPosts), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(34395)
            ]
    }
});
const DynamicSectionTermly = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2771).then(__webpack_require__.bind(__webpack_require__, 52771)).then((mod)=>mod.SectionTermly), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(52771)
            ]
    }
});
const DynamicSectionNewsletterV2 = dynamic_default()(()=>__webpack_require__.e(/* import() */ 3952).then(__webpack_require__.bind(__webpack_require__, 63952)).then((mod)=>mod.SectionNewsletterV2), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(63952)
            ]
    }
});
const DynamicSectionShouldIUseHydrogen = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9587).then(__webpack_require__.bind(__webpack_require__, 39587)).then((mod)=>mod.SectionShouldIUseHydrogen), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(39587)
            ]
    }
});
const DynamicSectionBanner = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4416).then(__webpack_require__.bind(__webpack_require__, 94416)).then((mod)=>mod.SectionBanner), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(94416)
            ]
    }
});
const DynamicSectionSideContent = dynamic_default()(()=>__webpack_require__.e(/* import() */ 801).then(__webpack_require__.bind(__webpack_require__, 70801)).then((mod)=>mod.SectionSideContent), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(70801)
            ]
    }
});
const DynamicSectionCards = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9675).then(__webpack_require__.bind(__webpack_require__, 89675)).then((mod)=>mod.SectionCards), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(89675)
            ]
    }
});
const DynamicSectionCallToAction = dynamic_default()(()=>__webpack_require__.e(/* import() */ 414).then(__webpack_require__.bind(__webpack_require__, 20414)).then((mod)=>mod.SectionCallToAction), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(20414)
            ]
    }
});
const DynamicSectionOpenPositions = dynamic_default()(()=>__webpack_require__.e(/* import() */ 8915).then(__webpack_require__.bind(__webpack_require__, 58915)).then((mod)=>mod.SectionOpenPositions), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(58915)
            ]
    }
});
const DynamicSectionSteps = dynamic_default()(()=>__webpack_require__.e(/* import() */ 6955).then(__webpack_require__.bind(__webpack_require__, 16955)).then((mod)=>mod.SectionSteps), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(16955)
            ]
    }
});
const DynamicSectionProcessSteps = dynamic_default()(()=>__webpack_require__.e(/* import() */ 1791).then(__webpack_require__.bind(__webpack_require__, 1791)).then((mod)=>mod.SectionProcessSteps), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(1791)
            ]
    }
});
const DynamicSectionAccordion = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9473).then(__webpack_require__.bind(__webpack_require__, 69473)).then((mod)=>mod.SectionAccordion), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69473)
            ]
    }
});
const DynamicSectionMasonryGallery = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9463).then(__webpack_require__.bind(__webpack_require__, 69463)).then((mod)=>mod.SectionMasonryGallery), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69463)
            ]
    }
});
const DynamicSectionAwardArticles = dynamic_default()(()=>__webpack_require__.e(/* import() */ 5099).then(__webpack_require__.bind(__webpack_require__, 55099)).then((mod)=>mod.SectionAwardArticles), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(55099)
            ]
    }
});
const DynamicSectionPeople = dynamic_default()(()=>__webpack_require__.e(/* import() */ 76).then(__webpack_require__.bind(__webpack_require__, 60076)).then((mod)=>mod.SectionPeople), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(60076)
            ]
    }
});
const DynamicSectionSideContentWithMedia = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9817).then(__webpack_require__.bind(__webpack_require__, 19817)).then((mod)=>mod.SectionSideContentWithMedia), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(19817)
            ]
    }
});
const DynamicSectionBlogHighlights = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9257).then(__webpack_require__.bind(__webpack_require__, 19257)).then((mod)=>mod.SectionBlogHighlights), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(19257)
            ]
    }
});
const DynamicSectionLogosWithTestimonials = dynamic_default()(()=>__webpack_require__.e(/* import() */ 786).then(__webpack_require__.bind(__webpack_require__, 60786)).then((mod)=>mod.SectionLogosWithTestimonials), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(60786)
            ]
    }
});
const DynamicSectionCTAButton = dynamic_default()(()=>__webpack_require__.e(/* import() */ 6984).then(__webpack_require__.bind(__webpack_require__, 46984)).then((mod)=>mod.SectionCTAButton), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(46984)
            ]
    }
});
const DynamicSectionHighlights = dynamic_default()(()=>__webpack_require__.e(/* import() */ 6943).then(__webpack_require__.bind(__webpack_require__, 16943)).then((mod)=>mod.SectionHighlights), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(16943)
            ]
    }
});
const DynamicSectionLogos = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4240).then(__webpack_require__.bind(__webpack_require__, 34240)).then((mod)=>mod.SectionLogos), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(34240)
            ]
    }
});
const PageBuilder = (param)=>{
    let { section  } = param;
    /**
   * We use two section import strategies:
   * - Dynamic - in order to minimise the size of bundle chunks, we prefer to import sections dynamically
   * - Static - to prevent the "blink" effect in most exposed sections we use static imports
   */ switch(section._type){
        // dynamic sections ======================================
        case "sectionHighlights":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionHighlights, {
                ...section
            });
        case "sectionBlogHighlights":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionBlogHighlights, {
                ...section
            });
        case "sectionLogosWithTestimonials":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionLogosWithTestimonials, {
                ...section
            });
        case "sectionSideContentWithMedia":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionSideContentWithMedia, {
                ...section
            });
        case "sectionAwardArticles":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionAwardArticles, {
                ...section
            });
        case "sectionProcessSteps":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionProcessSteps, {
                ...section
            });
        case "sectionMasonryGallery":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionMasonryGallery, {
                ...section
            });
        case "sectionAccordion":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionAccordion, {
                ...section
            });
        case "sectionSteps":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionSteps, {
                ...section
            });
        case "sectionShouldIUseHydrogen":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionShouldIUseHydrogen, {
                ...section
            });
        case "sectionBanner":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionBanner, {
                ...section
            });
        case "sectionSideContent":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionSideContent, {
                ...section
            });
        case "sectionCards":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionCards, {
                ...section
            });
        case "sectionCallToAction":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionCallToAction, {
                ...section
            });
        case "sectionNewsletterV2":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionNewsletterV2, {
                ...section
            });
        case "sectionTermly":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionTermly, {
                ...section
            });
        case "sectionFeaturedBlogPosts":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionFeaturedBlogPosts, {
                ...section
            });
        case "sectionSocialMediaEmbed":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionSocialMediaEmbed, {
                ...section
            });
        case "sectionNewsletter":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionNewsletter, {
                ...section
            });
        case "sectionDoubleMediaWithBackground":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionDoubleMediaWithBackground, {
                ...section
            });
        case "sectionArticleAuthor":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionArticleAuthor, {
                ...section
            });
        case "sectionArticleChapter":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionArticleChapter, {
                ...section
            });
        case "sectionSingleMediaWithDescription":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionSingleMediaWithDescription, {
                ...section
            });
        case "sectionVideoTestimonials":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionVideoTestimonials, {
                ...section
            });
        case "sectionTextBlocks":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionTextBlocks, {
                ...section
            });
        case "sectionTextBlockWithLink":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionTextBlockWithLink, {
                ...section
            });
        case "sectionCaseStudyDetails":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionCaseStudyDetails, {
                ...section
            });
        case "sectionNextProject":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionNextProject, {
                ...section
            });
        case "sectionCardSlider":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionCardSlider, {
                ...section
            });
        case "sectionQuote":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionQuote, {
                ...section
            });
        case "sectionEditorialRichText":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionEditorialRichText, {
                ...section
            });
        case "sectionCaseStudyCards":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionCaseStudyCards, {
                ...section
            });
        case "sectionServicesListing":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionServicesListing, {
                ...section
            });
        case "sectionTechstackSlider":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionTechstackSlider, {
                ...section
            });
        case "sectionOpenPositions":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionOpenPositions, {
                ...section
            });
        case "sectionPeople":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionPeople, {
                ...section
            });
        case "sectionCTAButton":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionCTAButton, {
                ...section
            });
        case "sectionLogos":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSectionLogos, {
                ...section
            });
        // static sections ==================================
        case "sectionHero":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHero, {
                ...section
            });
        case "sectionIntroTexts":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionIntroTexts, {
                ...section
            });
        case "sectionCaseStudyHero":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionCaseStudyHero, {
                ...section
            });
        case "sectionProjectCardGrid":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionProjectCardGrid, {
                ...section
            });
        case "sectionHomeHero":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHomeHero, {
                ...section
            });
        case "sectionProjectCard":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionProjectCard, {
                ...section
            });
        case "sectionArticleDetails":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionArticleDetails, {
                ...section
            });
        case "sectionArticlesLandingPage":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionArticlesLandingPage, {
                ...section
            });
        case "sectionContact":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContact, {
                ...section
            });
        case "sectionSideTextBlock":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionSideTextBlock, {
                ...section
            });
        case "sectionServices":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionServices, {
                ...section
            });
        case "sectionArticleContents":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionArticleContents, {
                ...section
            });
        case "sectionArticleRelated":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionArticleRelated, {
                ...section
            });
        default:
            return null;
    }
};

;// CONCATENATED MODULE: ../../libs/page-builder/src/index.ts


;// CONCATENATED MODULE: ../../libs/page/src/lib/PasswordProtected/PasswordProtected.tsx






const PasswordProtectedContainer = (0,src/* styled */.zo)("div", {
    display: "grid",
    gridTemplateColumns: "auto",
    gridTemplateRows: "auto auto",
    gridGap: "$64",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "$darkThemeBackground",
    padding: "$144 $20"
});
const LinkWrapper = (0,src/* styled */.zo)("div", {
    display: "grid",
    justifyContent: "center"
});
const PasswordProtected_StyledLink = (0,src/* styled */.zo)(components_src/* Link */.rU, {
    width: "fit-content",
    alignSelf: "center"
});
const PasswordWrapper = (0,src/* styled */.zo)("div", {
    backgroundColor: "$white",
    borderRadius: "$rBoxes",
    padding: "$32",
    width: "100%",
    maxWidth: "439px",
    display: "grid",
    gridGap: "$32"
});
const PasswordProtected_Title = (0,src/* styled */.zo)("p", {
    projectFont: "heading08",
    color: "$textPrimaryBlack"
});
const Subtitle = (0,src/* styled */.zo)("p", {
    projectFont: "heading08",
    color: "$gray300"
});
const FormWrap = (0,src/* styled */.zo)("div", {
    display: "grid",
    gridTemplateColumns: "1fr auto",
    gap: "$16"
});
const InputWrap = (0,src/* styled */.zo)("div", {
    display: "grid"
});
const TextInput = (0,src/* styled */.zo)("input", {
    width: "100%",
    height: "100%",
    borderRadius: "$r2",
    projectFont: "body04",
    border: "1px solid $black_02",
    color: "$black",
    transition: "color 250ms",
    padding: "$12 $20",
    textAlign: "start",
    "&::placeholder": {
        color: "$black_06"
    },
    "&:focus-visible": {
        outline: "$focusBlue solid 3px;"
    },
    variants: {
        isError: {
            true: {
                borderColor: "$errorRed"
            }
        }
    }
});
const FormError = (0,src/* styled */.zo)("div", {
    projectFont: "ui04",
    color: "$errorRed",
    display: "flex",
    flexDirection: "row",
    columnGap: "$4",
    alignItems: "center",
    justifyContent: "flex-start",
    visibility: "hidden",
    minHeight: "$24",
    variants: {
        isVisible: {
            true: {
                visibility: "visible"
            }
        }
    }
});
const ErrorMessage = (param)=>/*#__PURE__*/ {
    let { message  } = param;
    return (0,jsx_runtime.jsx)(FormError, {
        isVisible: !!message,
        children: !!message && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src/* Error */.jj, {}),
                message
            ]
        })
    });
};
const PasswordProtected = (param)=>{
    let { isPasswordProtected , password , children  } = param;
    const { t  } = (0,es/* useTranslation */.$G)("passwordProtected");
    const [passwordInput, setPasswordInput] = (0,react.useState)("");
    const [error, setError] = (0,react.useState)("");
    const [isPasswordValid, setIsPasswordValid] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const root = document.body;
        if (isPasswordValid || !isPasswordProtected) {
            root.style.setProperty("background-color", "var(--main-bg-color)");
        } else {
            root.style.setProperty("background-color", "#121212");
        }
    }, [
        isPasswordValid,
        isPasswordProtected
    ]);
    const submitPassword = ()=>{
        if (passwordInput === password) {
            setIsPasswordValid(true);
        } else {
            setError(String(t("invalidPassword")));
        }
    };
    const validateField = (value)=>{
        let error = "";
        if (!value.trim()) {
            error = t("required");
        }
        return error;
    };
    const handlePasswordInput = (e)=>{
        const { value  } = e.target;
        const error = validateField(value);
        setError(error);
        setPasswordInput(value);
    };
    return isPasswordValid || !isPasswordProtected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(PasswordProtectedContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordProtected_StyledLink, {
                    appearance: "containedTransparent",
                    href: "/work",
                    children: "Go Back"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PasswordWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordProtected_Title, {
                                children: t("title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                                children: t("subtitle")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormWrap, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputWrap, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput, {
                                        type: "password",
                                        placeholder: String(t("enterPassword")),
                                        value: passwordInput,
                                        onChange: handlePasswordInput,
                                        isError: !!error
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage, {
                                        message: error
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_src/* Button */.zx, {
                                appearance: "containedBlack",
                                onClick: submitPassword,
                                children: t("enterPassword")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../libs/page/src/lib/DefaultPage/DefaultPage.tsx




const SidebarPageLayout = (0,src/* styled */.zo)("div", {
    position: "relative",
    "@lg": {
        display: "grid",
        gridTemplateColumns: "minmax(0,1fr) minmax(0,2fr) minmax(0,.25fr)"
    }
});
const SidebarPageLayoutContainer = (0,src/* styled */.zo)("div", {
    maxWidth: "$containerMaxWidthForSidebarLayout"
});
const PageWrapper = (0,src/* styled */.zo)("div", {
    variants: {
        addBottomMargin: {
            true: {
                marginBottom: "$72",
                "@lg": {
                    marginBottom: "$96"
                }
            }
        }
    }
});
const DefaultPage = (args)=>{
    const { headerSection , pageBuilder , sidebarSection , addBottomMargin , relatedArticles , isPasswordProtected =false , password ="" , title , isVisuallyHiddenTitle  } = args;
    const hiddenPageTitle = isVisuallyHiddenTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
        className: "sr-only",
        children: title
    }) : null;
    const headerElement = headerSection ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PageBuilder, {
        section: {
            ...headerSection,
            priority: true
        }
    }) : null;
    const sectionElements = pageBuilder === null || pageBuilder === void 0 ? void 0 : pageBuilder.map((section, index)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageBuilder, {
            section: {
                ...section,
                priority: index === 0 || index === 1
            }
        }, section._key || "section-".concat(index));
    });
    if (!sidebarSection) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageWrapper, {
            addBottomMargin: isPasswordProtected ? false : addBottomMargin,
            children: [
                hiddenPageTitle,
                headerElement,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordProtected, {
                    password: password,
                    isPasswordProtected: isPasswordProtected,
                    children: sectionElements
                })
            ]
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageWrapper, {
            addBottomMargin: isPasswordProtected ? false : addBottomMargin,
            children: [
                hiddenPageTitle,
                headerElement,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordProtected, {
                    password: password,
                    isPasswordProtected: isPasswordProtected,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidebarPageLayout, {
                                children: [
                                    sidebarSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageBuilder, {
                                        section: {
                                            ...sidebarSection
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarPageLayoutContainer, {
                                        children: sectionElements
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                                ]
                            }),
                            relatedArticles && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageBuilder, {
                                section: {
                                    ...relatedArticles
                                }
                            })
                        ]
                    })
                })
            ]
        });
    }
};

;// CONCATENATED MODULE: ../../libs/page/src/index.ts




/***/ })

}]);